import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/api';

function ForgotPasswordPage() {
  const [email, setEmail]     = useState('');
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await forgotPassword({ email });
      setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="a-auth-page">
      <div className="a-auth-card">
        <div className="a-auth-header">
          <img src="/uploads/scala-logo.png" alt="SCALA" className="a-auth-header__logo" />
          <div className="a-auth-header__title">SCALA Performer Registry</div>
          <div className="a-auth-header__subtitle">Celebrating Songwriting</div>
        </div>
        <div className="a-auth-body">
          <h2>Reset Password</h2>
          {error && <div className="a-error">{error}</div>}
          {sent ? (
            <div className="a-success">
              If that email is registered, a reset link has been sent. Check your inbox.
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="a-field">
                <label className="a-label">Email Address</label>
                <input className="a-input" type="email" value={email}
                  onChange={e => setEmail(e.target.value)} required autoFocus />
              </div>
              <button type="submit" className="a-btn a-btn--navy a-btn--full" disabled={loading}
                style={{ marginTop: '0.5rem' }}>
                {loading ? 'Sending…' : 'Send Reset Link'}
              </button>
            </form>
          )}
          <p style={{ textAlign: 'center', marginTop: '1.25rem', fontSize: '0.875rem', color: '#6b7280' }}>
            <Link to="/login">Back to sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
